export default (state = false, action) => {
  switch (action.type) {
    case 'MOBILE_DETERMINE':
      return true;
    default:
      return state;
  }
};
